import {
  GitIntegrationPlatformSchema,
  type GitIntegrationPlatformType,
} from '@terra/shared-schemas-git';

export const GIT_PATH_NAME = 'git';

export const GITHUB_ISSUES_WEBHOOK_ROUTE_SEGMENT = 'github-issues';

export const GITHUB_ISSUES_APP_TENANT_HEADER =
  'x-terra-github-issues-tenant-id';

export const buildGithubIssuesAppInstallationTenantCacheKey = ({
  gitHubInstallationId,
}: {
  gitHubInstallationId: string;
}): string => `github_issues_app_installation_${gitHubInstallationId.trim()}`;

export const buildGithubIssuesWebhookSecretCacheKey = ({
  tenantId,
}: {
  tenantId: string;
}): string => `webhook_secret_github_issues_${tenantId}`;

export const buildGithubIssuesWebhookUrl = ({
  gatewayPublicUrl,
  tenantId,
}: {
  gatewayPublicUrl: string;
  tenantId: string;
}): string =>
  `${gatewayPublicUrl.replace(/\/+$/, '')}/${GIT_PATH_NAME}/webhooks/${GITHUB_ISSUES_WEBHOOK_ROUTE_SEGMENT}/${tenantId}`;

export const ENV_BASED_ZIP_UPLOAD = 'ENV_BASED_ZIP_UPLOAD';

export const isLocalPathIntegration = ({
  platform,
  name,
}: {
  platform: GitIntegrationPlatformType;
  name: string;
}): boolean =>
  platform === GitIntegrationPlatformSchema.enum.ZIP_UPLOAD &&
  name === ENV_BASED_ZIP_UPLOAD;

const getGitWebhookProvider = (
  platform: GitIntegrationPlatformType,
): 'github' | 'gitlab' | 'azure_devops' | 'bitbucket' => {
  switch (platform) {
    case GitIntegrationPlatformSchema.enum.GITHUB:
    case GitIntegrationPlatformSchema.enum.GITHUB_ENTERPRISE:
      return 'github';
    case GitIntegrationPlatformSchema.enum.GITLAB:
    case GitIntegrationPlatformSchema.enum.GITLAB_SELF_HOSTED:
      return 'gitlab';
    case GitIntegrationPlatformSchema.enum.AZURE_DEVOPS:
      return 'azure_devops';
    case GitIntegrationPlatformSchema.enum.BITBUCKET:
      return 'bitbucket';
    default:
      throw new Error(`Platform ${platform} does not support webhook secrets`);
  }
};

export const buildGitWebhookSecretCacheKey = ({
  tenantId,
  platform,
}: {
  tenantId: string;
  platform: GitIntegrationPlatformType;
}): string => `webhook_secret_${getGitWebhookProvider(platform)}_${tenantId}`;
